// Form submission utilities — routes through FormSubmit to maurizio@terrigno.ca
// User does not see any email address on the public site (option C)

const FORMSUBMIT_ENDPOINT = "https://formsubmit.co/maurizio@terrigno.ca";

/**
 * Submit a form payload to FormSubmit.
 * Uses mode:"no-cors" so the request fires without triggering CORS errors;
 * we can't read the response, but the data reaches FormSubmit successfully.
 * Also stores the payload locally as a backup record.
 *
 * @param {Object} payload - key/value object of fields to submit
 * @param {Object} options - { subject, source, honeypot }
 */
export async function submitForm(payload, options = {}) {
  const { subject, source, honeypot } = options;

  // Spam check: if the honeypot field has any value, silently drop
  if (honeypot) return { ok: false, spam: true };

  // Backup record in browser
  try {
    const key = "foy_submissions";
    const list = JSON.parse(localStorage.getItem(key) || "[]");
    list.push({ ...payload, source: source || "unknown", ts: Date.now() });
    localStorage.setItem(key, JSON.stringify(list));
  } catch (_e) {
    /* ignore */
  }

  // Build FormData for FormSubmit
  const fd = new FormData();
  Object.entries(payload).forEach(([k, v]) => {
    if (v !== undefined && v !== null) fd.append(k, String(v));
  });
  fd.append("_subject", subject || `New ${source || "form"} submission \u2014 FOYEVOO`);
  fd.append("_template", "table");
  fd.append("_captcha", "false");
  fd.append("_honey", "");

  try {
    await fetch(FORMSUBMIT_ENDPOINT, {
      method: "POST",
      body: fd,
      mode: "no-cors",
    });
    return { ok: true };
  } catch (_err) {
    return { ok: false, network: true };
  }
}
